import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AnalyticsId } from "./constants.js";
import styles from "./components/List/styles.module.scss";
const Item = ({ children }) => /* @__PURE__ */ jsx("li", { className: styles.list__item, children });
const List = ({ children, className, testId, variant = "bullet", margin }) => {
  const CustomTag = ["numbered", "alphabetical"].includes(variant) ? "ol" : "ul";
  const listClasses = classNames(styles.list, styles[`list--${variant}`], margin && styles["list--margin"], className);
  return /* @__PURE__ */ jsx(CustomTag, { className: listClasses, "data-testid": testId, "data-analyticsid": AnalyticsId.List, children });
};
List.Item = Item;
export {
  List as L
};
//# sourceMappingURL=List.js.map
